
import React from 'react';
import AgentTimelineVisualizer from './timeline/AgentTimelineVisualizer';
import { AgentRole } from './types';

interface AgentInteractionTimelineProps {
  sessionId?: string;
  agentType?: AgentRole;
  limit?: number;
}

const AgentInteractionTimeline: React.FC<AgentInteractionTimelineProps> = ({
  sessionId,
  agentType,
  limit = 20
}) => {
  return (
    <AgentTimelineVisualizer 
      sessionId={sessionId}
      agentType={agentType}
      limit={limit}
    />
  );
};

export default AgentInteractionTimeline;
